import { createContext, ReactNode, useContext } from "react";

import { VersionedEntityType } from "../utils";

import { Entity } from "@/queries";

export type EntitySelection =
  | { type: "version"; version: number | undefined }
  | { type: "label"; label: string };

interface ChooseEntityVariantContextValue {
  entity: Entity<VersionedEntityType>;
  readonly: boolean;
  multiSelect: boolean;
  selectedEntities: Entity[];
  onSelect: (selection: EntitySelection) => void;
  onOpenChange: (open: boolean) => void;
  onBack: () => void;
}

const ChooseEntityVariantContext = createContext<ChooseEntityVariantContextValue | undefined>(
  undefined,
);

export const useChooseEntityVariant = () => {
  const context = useContext(ChooseEntityVariantContext);
  if (!context) {
    throw new Error("useChooseEntityVariant must be used within ChooseEntityVariantProvider");
  }
  return context;
};

interface ChooseEntityVariantProviderProps {
  entity: Entity<VersionedEntityType>;
  readonly?: boolean;
  multiSelect?: boolean;
  selectedEntities?: Entity[];
  onSelect: (selection: EntitySelection) => void;
  onOpenChange: (open: boolean) => void;
  onBack: () => void;
  children: ReactNode;
}

export const ChooseEntityVariantProvider = ({
  entity,
  readonly = false,
  multiSelect = false,
  selectedEntities = [],
  onSelect,
  onOpenChange,
  onBack,
  children,
}: ChooseEntityVariantProviderProps) => {
  const value: ChooseEntityVariantContextValue = {
    entity,
    readonly,
    multiSelect,
    selectedEntities,
    onSelect,
    onOpenChange,
    onBack,
  };

  return (
    <ChooseEntityVariantContext.Provider value={value}>
      {children}
    </ChooseEntityVariantContext.Provider>
  );
};
